define([
	"dojo/_base/declare",
	"csi/_base/modules",
	"csi/_base/underscore",
	"csi/def/ActionFactory",
	"csi/def/Rule",
	"csi/reflection",
	"csi/resolver",
	"csi/sessionConstants",
	"csi/util",
	"csi/xml"
], function(declare, modules, _, ActionFactory, Rule, reflection, resolver, sessionConstants, util, xml) {

	return declare(null, {
		// Boolean: indicates if view should be read-only
		bReadOnly: false,

		// Action: switchboard action for referenced view - must contain ViewRef relative to Tabs view root node
		switchboard: null,

		// String: target class for view - m_idView is defined on the target class
		target: null,

		constructor: function(/*XMLNode?*/xn) {
			const bUser = util.getBooleanProperty(xn, "User");

			this.m_idView = util.getProperty(xn, 'Id');
			this.m_url = util.getProperty(xn, 'URL', bUser ? sessionConstants.userUrl : null);
			this.m_path = util.getProperty(xn, 'Path');
			this.m_rules = util.getDefs(xn, 'Rule', Rule);

			this.bReadOnly = util.getBooleanProperty(xn, "ReadOnly");
			this.modules = util.getProperty(xn, "Modules");
			this.notModules = util.getProperty(xn, "NotModules");
			this.target = util.getProperty(xn, "Target");
			this.switchboard = ActionFactory.getActionDef(xn, "Switchboard");
			this.accessTab = util.getProperty(xn, 'AccessTab');
		},

		isValid: function() {
			return !!this.m_idView &&
				(!this.modules || modules.hasModules(this.modules)) &&
				(!this.notModules || !modules.hasModules(this.notModules));
		},

		changesRoot: function() {
			return this.m_url || this.m_path;
		},

		getPath: function() {
			return this.m_path;
		},

		getUrl: function(/*Node*/node) {
			// summary: return url to which path is relative
			return this.m_url || xml.nodeGetURL(node);
		},

		getQueryParts: function(/*Node*/node, /*String[]*/urls, /*String[]*/paths) {
			var url = this.getUrl(node);

			if (xml.isValidURL(url)) {
				if (this.changesRoot()) {
					if (this.m_path) {
						// if tab uses path, then add both url and path to query
						urls.push(url);
						paths.push(this.m_path);
					} else if (url != node.$URL) {
						// otherwise just add url if different than current context
						urls.push(url);
					}
				}

				// add paths needed by rules
				_.each(this.m_rules, function(rule) {
					if (rule.m_path) {
						urls.push(url);
						paths.push(rule.m_path);
					}
				});
			}
		},

		getRootNode: function(/*Context*/ctx, /*Boolean*/bForce) {
			// summary: find root node of view
			if (this.target) return null;

			var node = ctx.getNode();
			var b = false;
			var onStep = function(nodeNext, nodePrevious, idRelation, bChild) {
				b = b || !bChild || !reflection.isRelationEditable(nodePrevious, idRelation, nodeNext, node, ctx);
			};

			if (this.m_url) {
				node = resolver.resolveNode(this.m_url, bForce, ctx.cache);
			}

			if (node && this.m_path) {
				node = ctx.cache.getPathNode(node, this.m_path, bForce, this.bReadOnly ? null : onStep);
				if (b) this.bReadOnly = true;
			}

			return node;
		},

		getRootNodeClass: function(/*Class?*/rc) {
			if (this.target) {
				return reflection.getClass(this.target);
			}

			if (this.m_url) {
				rc = reflection.getNodeClass(resolver.resolveNode(this.m_url, true));
			}

			if (rc && this.m_path) {
				rc = rc.getPathClass(this.m_path);
			}

			return rc;
		},

		resolve: function(/*LocaleResolver*/lr, /*Class*/rcRoot, /*Node*/nodeRoot) {
			// summary: resolve action class and strings
			if (this.switchboard) {
				this.switchboard.resolve(lr, rcRoot, nodeRoot);
			}
		}
	});
});